/**
 * Sdbm hash function; see http://www.cse.yorku.ca/~oz/hash.html
 *
 * @param {string} str
 */
function hash(str) {
	let code = 0;
	for (const char of str.split("")) {
		code = char.charCodeAt(0) + (code << 6) + (code << 16) - code;
	}

	return code;
}

const COLORS = ["var(--blue-500)", "var(--green-500)", "var(--orange-500)", "var(--red-500)"];

/** @param {string} name */
export default function color(name) {
	const index = Math.abs(hash(name)) % COLORS.length;

	return /** @type {string} */ (COLORS[index]);
}
